const PaymentMethod = {
  getCardList: {
    url: `/user-subscription/card-list`,
    method: "GET",
  },
  saveRemoveCard: {
    url: `/user-subscription/card`,
    method: "POST",
  },
  paymentSetting: {
    url: "/setting",
    method: "GET",
  },
};
export default PaymentMethod;
